export default "__VITE_ASSET__C5CI$ftA__"